import type { FaireProductEntity } from "../../entity_types/product";

export const p_k9bezd5a6j: FaireProductEntity = {
  token: "p_k9bezd5a6j",
  type: "product",
  name: "Spot Of Tea Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9549a7f972587f8b7331c9a38c38db47b46523a397ec01decb0623780f46985b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16fd6f7e1b80309f7de26a0aae4ea10ccb3ab20bf6a828611b0dd2cef089d3e9.jpeg",
    "https://cdn.faire.com/fastly/0d5c55de2b35947eba4042e0709bdd75d91945036f4859c8e377314565b3975a.jpeg",
    "https://cdn.faire.com/fastly/e3ce3a6a4aad63f23aa2a51fbd62e42598bd7c743490f3fab18ae93632f2e1c2.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:13.863Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
